module.exports = __webpack_public_path__ + "img/header.e222cc25.png";